//#region IMPORT
import React from 'react';
/** Components Import */
import {
  Box,
  Button,
  IconButton,
  Paper,
  TextField,
  Typography,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import {
  Close as CloseIcon,
  PersonAdd as PersonAddIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  AccountCircle as AccountCircleIcon,
  EventNote as EventNoteIcon,
} from '@mui/icons-material';

import { AuthButton, Dialog } from '../../../../Components/MUIs';
import { DatePicker } from '../../../../Components/MUIs';

import Commons from '../../../../Services/Common/Common';

/** AG-grid Import */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';

import dayjs from 'dayjs';
import { FileForm } from '../../../../Components/FileForm';
import {
  getColumnDefs1,
  getColumnDefs2,
  getAttendeePickerColumnDefs,
  getAttendeeWorkerKey,
  mapWorkerToAttendeeRow,
  normalizeAttendeeWorkerRow,
} from './SAC_BASIC_ColumnDefs';
import { useSelector, useDispatch } from 'react-redux';
import { setYear, setSearchText } from '../../../../Reducer/SearchReducer';

/**
1. 회의등록
2. 참석자 참석여부 알림 요청하기 
3. 회의 개최클릭 -> 회의 개최중으로 상태변경
4. 회의결과등록
5. 회의 완료로 상태변경
6. 참석자한테 회의결과에 대한 서명요청 (실제 참석여부를 확인하는 용도)
7. 대표자에게 결재요청
8. 회의 만료로 상태변경
**/

//#endregion
function SAC_BASIC(props) {
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [externalUserMemberModalOpen, setExternalUserMemberModalOpen] =
    React.useState(false);
  const [externalUserMemberForm, setExternalUserMemberForm] = React.useState({
    depNm: '',
    rank: '',
    position: '',
    name: '',
    tel: '',
  });

  const ConfirmAddExternalUserCommitteeMember = () => {
    const nameTrim = externalUserMemberForm.name.trim();
    if (!nameTrim) {
      props.dispatch(
        props.showSnackbar({
          message: '성명을 입력해주세요.',
          type: 'warning',
        })
      );
      return;
    }
    const id = `EXT_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
    const newRow = {
      id,
      depNm: externalUserMemberForm.depNm.trim(),
      rank: externalUserMemberForm.rank.trim(),
      position: externalUserMemberForm.position.trim(),
      name: nameTrim,
      tel: externalUserMemberForm.tel.trim(),
      gubun: '0',
      checkYn: 'N',
      attendYn: 'N',
      checkPath: '',
      nonAttendReason: '',
    };
    const next0 = [...props.attendeeData0, newRow];
    props.setAttendeeData0(next0);
    props.setModalRowData2((prev) => ({
      ...prev,
      totalWorkers: next0.length + props.attendeeData1.length,
    }));
    setExternalUserMemberForm({
      depNm: '',
      rank: '',
      position: '',
      name: '',
      tel: '',
    });
    setExternalUserMemberModalOpen(false);
  };

  // 협의체회의록 그리드 컬럼
  const columnDefs1 = getColumnDefs1({
    DeleteNewRow1: props.DeleteNewRow1,
    RestoreRow1: props.RestoreRow1,
    gridRef1: props.gridRef1,
    rowData1: props.rowData1,
    selectedRowNosRef: props.selectedRowNosRef,
    lastCheckedIndexRef: props.lastCheckedIndexRef,
    handleRowSelection: props.handleRowSelection,
    handleMeetingStart: props.handleMeetingStart,
    SignRequest: props.SignRequest,
    PopupClickEvent5: props.PopupClickEvent5,
  });
  //#endregion
  return (
    <>
      <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid xs={4} md={12}>
          <AuthButton
            menuId="SafetyCommittee"
            searchYn="Y"
            addYn="N"
            saveYn="Y"
            applyClick={() => {
              // 선택된 행이 있는지 확인
              if (
                !props.selectedRowData1 ||
                props.selectedRowData1.length === 0
              ) {
                props.dispatch(
                  props.showSnackbar({
                    message: '결재요청할 회의를 선택해주세요.',
                    type: 'warning',
                  })
                );
                return;
              }
              // 선택된 모든 행에 대해 결재요청
              props.selectedRowData1.forEach((selectedData) => {
                props.SignRequest('1', selectedData); // '1'은 결재요청 구분값
              });
            }}
            fileValidFc={() => {
              if (!props.validateSelection()) {
                return false; // 실패
              }
              return true; // 성공
            }}
            buttonsSx={{
              '& .MuiButton-root': {
                margin: '3px', // 버튼들의 마진을 4px로 줄이기
              },
            }}
            printItem={[
              {
                name: '회의록',
                onClick: (e) => {
                  props.PrintLogic3(searchInfo.year);
                },
              },
            ]}
            printClick={() => {
              if (!props.validateSelection()) return;
              props.PrintLogic3(searchInfo.year);
            }}
            searchClick={(e) => {
              if (!props.validateSelection()) return;

              dispatch(setSearchText(e));
              props.gridRef1.current.api.setQuickFilter(e);
            }}
            saveClick={() => {
              if (!props.validateSelection()) return;

              if (
                !props.deletedRowData1 ||
                props.deletedRowData1.length === 0
              ) {
                props.dispatch(
                  props.showSnackbar({
                    message: '삭제할 행을 선택하세요.',
                    type: 'warning',
                  })
                );
                return;
              }

              const deletedCount = props.deletedRowData1.length;

              props.deleteHandler1
                .DeleteLogic()
                .then(() => {
                  if (deletedCount > 0) {
                    props.SaveActionLog(props.deletedRowData1, {
                      menuId: props.SCREEN_MENU_ID,
                      coCd:
                        props.userInfo.authCd === 'ADMIN'
                          ? ''
                          : props.userInfo.coCd,
                      userId: props.userInfo.userid,
                      logResult: 'SUCCESS',
                    });

                    props.dispatch(
                      props.showSnackbar({
                        message: '삭제되었습니다.',
                        type: 'success',
                      })
                    );

                    props.SearchLogic1(searchInfo.custCd || '');
                  }
                })
                .catch((error) => {
                  props.SaveActionLog(props.deletedRowData1, {
                    menuId: props.SCREEN_MENU_ID,
                    coCd:
                      props.userInfo.authCd === 'ADMIN'
                        ? ''
                        : props.userInfo.coCd,
                    userId: props.userInfo.userid,
                    logResult: 'ERROR',
                    errorMsg: error.message,
                  });
                  console.error('삭제 실패:', error);
                });
            }}
            conditions={[
              {
                type: 'datePicker',
                views: ['year'],
                openTo: 'year',
                title: '기간',
                name: Commons.IsMobile() ? searchInfo.year : '조회연도', //기간
                value: searchInfo.year ? dayjs(searchInfo.year) : dayjs(),
                onChange: async (date) => {
                  let changeYear = dayjs(date).format('YYYY');
                  if (date) {
                    dispatch(setYear(changeYear));
                    if (!props.validateSelection()) return;
                    await props.SearchLogic1(searchInfo.custCd || '');
                  }
                },
                currentLocale: 'ko',
                format: 'YYYY',
              },
              // ADMIN이면 추가 combo
              ...(props.userInfo.authCd === 'ADMIN'
                ? [
                    {
                      type: 'combo',
                      name: '회사',
                      items: searchInfo.coList,
                      value: searchInfo.coCd,
                      onChange: async (e) => {
                        await props.handleCoChange(e);
                        if (!props.validateSelection()) return;
                        await props.SearchLogic1(searchInfo.custCd || '');
                      },
                    },
                  ]
                : []),
              {
                type: 'combo',
                name: '사업장',
                items: searchInfo.custList,
                value: searchInfo.custCd,
                onChange: async (e) => {
                  await props.handleCustChange(e);
                  if (!props.validateSelection()) return;
                  await props.SearchLogic1(e || '');
                },
              },
            ]}
            grids={
              <BusinessGridCommon
                getRowId={(params) => {
                  return params.data.no;
                }}
                deleteYn1="Y"
                gridRef={props.gridRef1}
                editable={true}
                columnDefs={columnDefs1}
                rowData={props.rowData1}
                setSelectedRowData={props.setSelectedRowData1}
                setChangedRowData={props.setChangedRowData1}
                rowSelection={'multiple'}
                refreshClick1={() => {
                  if (!props.validateSelection()) return;

                  props.SearchLogic1(searchInfo.custCd || '');
                }}
                addClick1={(e) => {
                  if (!props.validateSelection()) return;
                  props.setModalRowData2({
                    chaebun: '',
                    proceedingsTitle: '',
                    proceedingsDate: dayjs().format('YYYY-MM-DD'), // 기본값 설정
                    proceedingsStartTime: null,
                    proceedingsEndTime: null,
                    proceedingsLocation: '',
                    totalWorkers: 0,
                  });

                  // 참석자 데이터 초기화
                  props.setAttendeeData0([]);
                  props.setAttendeeData1([]);
                  props.ResetImage();
                  // 회의안건 데이터 초기화
                  props.setMeetingAgendaData([]);

                  const result = props.handleAttendeeSearch();
                  const totalWorkers = result?.length || 0;

                  props.setModalRowData2({
                    totalWorkers: totalWorkers,
                  });

                  props.setModalToggle2(true);
                }}
                deleteClick1={() => {
                  if (!props.validateSelection()) return;

                  props.DeleteLogic1();
                }}
                onCellClicked={(e) => {
                  // 필요 시 특정 행 선택 등 처리
                  const gridApi = props.gridRef1.current.api;
                  const clickedRowIndex = e.rowIndex;

                  const isCheckboxClick = e.event?.target?.type === 'checkbox';

                  if (!isCheckboxClick) {
                    gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                    gridApi.setFocusedCell(clickedRowIndex, 'coNm');

                    const copied = JSON.parse(JSON.stringify(e.data));
                    props.handleRowSelection(copied, clickedRowIndex);

                    gridApi
                      .getDisplayedRowAtIndex(clickedRowIndex)
                      ?.setSelected(true, false);
                  }
                }}
                onSelectionChanged={() => {
                  const gridApi = props.gridRef1?.current?.api;
                  const selectedNodes = gridApi.getSelectedNodes();
                  const selectedData = selectedNodes.map((n) => n.data);
                  props.selectedRowNosRef.current = new Set(
                    selectedData.map((r) => r.no)
                  );
                  props.setSelectedRowData1(selectedData);
                }}
              />
            }
          />
        </Grid>
        {/* 회의록 팝업 창 */}
        {props.modalToggle2 && (
          <Dialog
            title={null}
            titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
            open={props.modalToggle2}
            onClose={() => props.setModalToggle2(false)}
            contentSx={{
              p: '0 !important',
              pt: '0 !important',
              pb: '0 !important',
              px: '0 !important',
              py: '0 !important',
              m: '0 !important',
              mt: '0 !important',
              overflow: 'hidden',
              height: '85vh',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
              '&.MuiDialogContent-root': {
                padding: '0 !important',
                paddingTop: '0 !important',
                height: '85vh',
                maxHeight: '85vh',
                display: 'flex',
                flexDirection: 'column',
              },
            }}
            sx={{
              '& .MuiDialog-paper': {
                height: '90vh',
                maxHeight: '90vh',
                overflow: 'hidden',
              },
            }}
            fullWidth
            maxWidth="md"
            saveButtonName="저장"
            closeButtonName="닫기"
            useSaveButton={true}
            useSaveAfterClose={false}
            useCloseButton={false}
            onSave={() => {
              props.SaveMeetingPopupCombined();
            }}
            content={
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  maxHeight: '90vh',
                  bgcolor: '#f6f7f8',
                  p: 0,
                  m: 0,
                  mt: 0,
                  pt: 0,
                  overflow: 'hidden',
                }}
              >
                {/* Top Navigation Bar */}
                <Paper
                  elevation={0}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #f0f2f4',
                    bgcolor: 'white',
                    px: 3,
                    py: 1.5,
                    flexShrink: 0,
                    zIndex: 20,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      color: '#111418',
                    }}
                  >
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(19, 127, 236, 0.1)',
                        color: 'primary.main',
                        borderRadius: 1.5,
                      }}
                    >
                      <EventNoteIcon sx={{ fontSize: 24 }} />
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#111418',
                        fontSize: 18,
                        fontWeight: 'bold',
                        letterSpacing: -0.15,
                      }}
                    >
                      회의정보
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() => props.setModalToggle2(false)}
                    sx={{
                      color: '#5f6368',
                      '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Paper>

                {/* Main Content - Scrollable */}
                <Box
                  sx={{
                    flex: 1,
                    p: 2,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    minHeight: 0,
                  }}
                >
                  {/* 회의 기본 정보 */}
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      mb: 2,
                      bgcolor: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                    }}
                  >
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body1"
                        sx={{
                          mb: 1,
                          fontWeight: 600,
                          color: '#111418',
                        }}
                      >
                        회의제목 <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        value={props.modalRowData2?.proceedingsTitle || ''}
                        onChange={(e) => {
                          const value = e.target.value.slice(0, 100); // 최대 100자 제한
                          props.setModalRowData2({
                            ...props.modalRowData2,
                            proceedingsTitle: value,
                          });
                        }}
                        fullWidth
                        required
                        error={!props.modalRowData2?.proceedingsTitle?.trim()}
                        inputProps={{
                          maxLength: 100,
                        }}
                        helperText={
                          !props.modalRowData2?.proceedingsTitle?.trim()
                            ? '회의제목을 입력해주세요.'
                            : `${(props.modalRowData2?.proceedingsTitle || '').length}/100`
                        }
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body1"
                        sx={{
                          mb: 1,
                          fontWeight: 600,
                          color: '#111418',
                        }}
                      >
                        회의일시
                      </Typography>
                      <Box
                        sx={{ display: 'flex', gap: 2, alignItems: 'center' }}
                      >
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ mb: 1, fontSize: '0.875rem' }}
                          >
                            회의일시 (YYYY-MM-DD)
                          </Typography>
                          <DatePicker
                            placeholder="회의일시"
                            value={
                              props.modalRowData2?.proceedingsDate
                                ? dayjs(
                                    props.modalRowData2.proceedingsDate,
                                    'YYYY-MM-DD'
                                  )
                                : dayjs()
                            }
                            onChange={(date) => {
                              const newData = {
                                ...props.modalRowData2,
                                proceedingsDate: date
                                  ? date.format('YYYY-MM-DD')
                                  : dayjs().format('YYYY-MM-DD'),
                              };
                              props.setModalRowData2(newData);
                            }}
                            format="YYYY-MM-DD"
                            views={['year', 'month', 'day']}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Box>

                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ mb: 1, fontSize: '0.875rem' }}
                          >
                            시작일시 (HH:mm)
                          </Typography>
                          <DatePicker
                            placeholder="시작일시"
                            value={
                              props.modalRowData2?.proceedingsStartTime || null
                            }
                            onChange={(date) =>
                              props.setModalRowData2({
                                ...props.modalRowData2,
                                proceedingsStartTime: date,
                              })
                            }
                            format="HH:mm"
                            views={['hours', 'minutes']}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Box>

                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ mb: 1, fontSize: '0.875rem' }}
                          >
                            종료일시 (HH:mm)
                          </Typography>
                          <DatePicker
                            placeholder="종료일시"
                            value={
                              props.modalRowData2?.proceedingsEndTime || null
                            }
                            onChange={(date) =>
                              props.setModalRowData2({
                                ...props.modalRowData2,
                                proceedingsEndTime: date,
                              })
                            }
                            format="HH:mm"
                            views={['hours', 'minutes']}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{
                          mb: 1,
                          fontWeight: 600,
                          color: '#111418',
                        }}
                      >
                        회의장소 <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        value={props.modalRowData2?.proceedingsLocation || ''}
                        onChange={(e) => {
                          const value = e.target.value.slice(0, 100); // 최대 100자 제한
                          props.setModalRowData2({
                            ...props.modalRowData2,
                            proceedingsLocation: value,
                          });
                        }}
                        fullWidth
                        required
                        error={
                          !props.modalRowData2?.proceedingsLocation?.trim()
                        }
                        inputProps={{
                          maxLength: 100,
                        }}
                        helperText={
                          !props.modalRowData2?.proceedingsLocation?.trim()
                            ? '회의장소를 입력해주세요.'
                            : `${(props.modalRowData2?.proceedingsLocation || '').length}/100`
                        }
                      />
                    </Box>
                  </Paper>

                  {/* 회의 참석자 정보 */}
                  <Paper
                    elevation={0}
                    sx={{
                      mb: 3,
                      p: 2,
                      bgcolor: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                    }}
                  >
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: '#111418',
                          mb: 0.5,
                        }}
                      >
                        사업장 총 근로자수({props.modalRowData3.length}명)
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#5f6368',
                          fontSize: 14,
                        }}
                      >
                        우리 사업장 근로자 중 회의참석자를 선택하세요. 각 위원
                        구분별로 참석인원을 추가할 수 있습니다.
                      </Typography>
                    </Box>

                    {/* 사용자위원 정보 */}
                    <div
                      className="ag-theme-alpine"
                      style={{ height: '500px', width: '100%' }}
                    >
                      <BusinessGridCommon
                        gridRef={props.gridRef2User}
                        addYn1={'Y'}
                        addClick1={() => {
                          void props.OpenAttendeeAddModal('0');
                        }}
                        other1={
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setExternalUserMemberModalOpen(true)}
                            sx={{ textTransform: 'none', mr: 0.5 }}
                          >
                            외부인원 직접입력
                          </Button>
                        }
                        deleteYn1={'N'}
                        refreshYn1={'N'}
                        title1={'사용자위원 정보'}
                        setSelectedRowData={() => {}}
                        columnDefs={getColumnDefs2({
                          setList: props.setAttendeeData0,
                        })}
                        rowData={props.attendeeData0}
                        defaultColDef={{
                          editable: false,
                          minWidth: 80,
                          resizable: true,
                          sortable: true,
                        }}
                        suppressToolPanel={true}
                        suppressMenuHide={true}
                        suppressColumnMoveAnimation={true}
                      />
                    </div>

                    {/* 근로자위원 정보 */}
                    <div
                      className="ag-theme-alpine"
                      style={{ marginTop: 16, height: '500px', width: '100%' }}
                    >
                      <BusinessGridCommon
                        gridRef={props.gridRef2Labor}
                        addYn1={'Y'}
                        addClick1={() => {
                          void props.OpenAttendeeAddModal('1');
                        }}
                        deleteYn1={'N'}
                        refreshYn1={'N'}
                        title1={'근로자위원 정보'}
                        setSelectedRowData={() => {}}
                        columnDefs={getColumnDefs2({
                          setList: props.setAttendeeData1,
                        })}
                        rowData={props.attendeeData1}
                        defaultColDef={{
                          editable: false,
                          minWidth: 80,
                          resizable: true,
                          sortable: true,
                        }}
                        suppressToolPanel={true}
                        suppressMenuHide={true}
                        suppressColumnMoveAnimation={true}
                      />
                    </div>
                  </Paper>

                  {/* 진행사진 업로드 */}
                  <Paper
                    elevation={0}
                    sx={{
                      mb: 3,
                      p: 3,
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      backgroundColor: 'white',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        fontWeight: 600,
                        color: '#111418',
                        fontSize: 16,
                      }}
                    >
                      진행사진 업로드
                    </Typography>

                    {/* FileForm 영역 */}
                    <Box sx={{ display: 'flex', gap: '1rem', mb: 2 }}>
                      <FileForm
                        datas={[
                          {
                            type: 'file',
                            name: '파일',
                            onChange: (event) => {
                              const fileList = event.target.files;
                              if (Object.keys(fileList).length === 0) return;

                              const file = fileList[0];

                              const validTypes = [
                                'image/jpeg',
                                'image/png',
                                'image/gif',
                                'image/bmp',
                                'image/svg+xml',
                              ];
                              if (!validTypes.includes(file.type)) {
                                props.dispatch(
                                  props.showSnackbar({
                                    message: '이미지 파일만 업로드 가능합니다.',
                                    type: 'warning',
                                  })
                                );
                                return false;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = (e) => {
                                fetch(e.target.result)
                                  .then((res) => res.blob())
                                  .then((blob) => {
                                    const image = new File(
                                      [blob],
                                      `${new Date()
                                        .toISOString()
                                        .replace(/T/, '')
                                        .replace(/\..+/, '')
                                        .replace(/-/g, '')
                                        .replace(/:/g, '')}.png`,
                                      {
                                        type: 'image/png',
                                      }
                                    );

                                    props.setInputs((prev) => ({
                                      ...prev,
                                      mapFile: image,
                                      filePath: `Business/${searchInfo.custCd}/SAC_BASIC/${file.name}`,
                                      fileName: file.name,
                                      saveName: file.name,
                                      newYn: 'Y',
                                    }));

                                    props.inputsRef.current = {
                                      ...props.inputsRef.current,
                                      mapFile: image,
                                      filePath: `Business/${searchInfo.custCd}/SAC_BASIC/${file.name}`,
                                      fileName: file.name,
                                      saveName: file.name,
                                      newYn: 'Y',
                                    };

                                    props.imgRef2.current = reader.result;
                                  });
                              };
                              reader.onerror = () => {};
                            },
                          },
                          {
                            name: '파일명',
                            value: props.inputsRef.current.fileName,
                            disabled: true,
                          },
                        ]}
                      />
                    </Box>

                    {/* 이미지 미리보기 + 삭제 버튼 */}
                    <Box
                      sx={{
                        border: '1px dashed #ccc',
                        borderRadius: 2,
                        padding: 2,
                        backgroundColor: '#fff',
                        minHeight: 150,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                      }}
                    >
                      {props.imgRef2.current ? (
                        <>
                          <img
                            src={props.imgRef2.current}
                            alt="진행사진 이미지"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '200px',
                              objectFit: 'contain',
                              borderRadius: 4,
                            }}
                          />
                          {!props.meetingAgendaData.some(
                            (item) => item.STATE === '만료'
                          ) && (
                            <IconButton
                              onClick={props.ResetImage}
                              sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: 'rgba(255,255,255,0.8)',
                                '&:hover': {
                                  backgroundColor: 'rgba(255,255,255,1)',
                                },
                              }}
                              size="small"
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          )}
                        </>
                      ) : (
                        <Typography color="text.secondary">
                          등록된 이미지가 없습니다.
                        </Typography>
                      )}
                    </Box>
                  </Paper>

                  {/* 회의 안건 그리드 */}
                  <Paper
                    elevation={0}
                    sx={{
                      mb: 3,
                      p: 3,
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      backgroundColor: 'white',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        fontWeight: 600,
                        color: '#111418',
                        fontSize: 16,
                      }}
                    >
                      회의 안건
                    </Typography>
                    {/* 회의안건 추가 버튼 */}
                    <Box sx={{ mb: 2 }}>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={props.addMeetingAgenda}
                        sx={{
                          mb: 2,
                          borderRadius: 2,
                          fontWeight: 600,
                          textTransform: 'none',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          '&:hover': {
                            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                          },
                        }}
                      >
                        회의안건 추가하기
                      </Button>
                    </Box>
                    {/* 삭제 안내 문구 */}
                    {props.meetingAgendaData.some(
                      (item) => item.deleteYn === 'Y'
                    ) && (
                      <Box
                        sx={{
                          mb: 2,
                          p: 2,
                          backgroundColor: '#fff3e0',
                          border: '2px solid #ff9800',
                          borderRadius: 2,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          boxShadow: '0 2px 8px rgba(255, 152, 0, 0.2)',
                        }}
                      >
                        <Box
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: '50%',
                            backgroundColor: '#ff9800',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '14px',
                          }}
                        >
                          !
                        </Box>
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 'bold',
                              color: '#e65100',
                              mb: 0.5,
                            }}
                          >
                            삭제 예정 안건이 있습니다
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#f57c00',
                            }}
                          >
                            저장 버튼을 클릭하면 빨간색으로 표시된 안건들이
                            영구적으로 삭제됩니다.
                          </Typography>
                        </Box>
                      </Box>
                    )}
                    <div
                      className="ag-theme-alpine"
                      style={{ height: '400px', width: '100%' }}
                    >
                      <AgGridReact
                        ref={props.gridRef5}
                        columnDefs={[
                          {
                            field: 'agendaName',
                            headerName: '안건명',
                            width: 200,
                            editable: true,
                            flex: 1,
                            cellEditor: 'agTextCellEditor',
                            cellEditorParams: {
                              maxLength: 500,
                            },
                            cellStyle: (params) => {
                              if (
                                !params.value?.trim() &&
                                params.data.deleteYn !== 'Y'
                              ) {
                                return {
                                  border: '2px solid #f44336',
                                  backgroundColor: '#ffebee',
                                };
                              }
                              return null;
                            },
                          },
                          {
                            field: 'resultDiscussion',
                            headerName: '의결사항',
                            width: 300,
                            editable: true,
                            flex: 2,
                            cellEditor: 'agTextCellEditor',
                            cellEditorParams: {
                              maxLength: 1000,
                            },
                            cellStyle: (params) => {
                              if (
                                !params.value?.trim() &&
                                params.data.deleteYn !== 'Y'
                              ) {
                                return {
                                  border: '2px solid #f44336',
                                  backgroundColor: '#ffebee',
                                };
                              }
                              return null;
                            },
                          },
                          {
                            field: 'person',
                            headerName: '담당부서/담당자',
                            width: 100,
                            editable: true,
                            flex: 1,
                            cellEditor: 'agTextCellEditor',
                            cellEditorParams: {
                              maxLength: 100,
                            },
                          },
                          {
                            field: 'processingDeadline',
                            headerName: '처리기한',
                            width: 100,
                            editable: true,
                            flex: 1,
                            cellEditor: 'agTextCellEditor',
                            cellEditorParams: {
                              maxLength: 100,
                            },
                          },
                          {
                            field: 'actions',
                            headerName: '삭제',
                            width: 80,
                            cellRenderer: (e) => {
                              if (
                                props.meetingAgendaData.some(
                                  (item) => item.STATE === '만료'
                                )
                              ) {
                                return null;
                              }

                              return (
                                <IconButton
                                  color="error"
                                  onClick={() =>
                                    props.deleteMeetingAgenda(e.data.id)
                                  }
                                  size="small"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              );
                            },
                            cellStyle: {
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            },
                          },
                        ]}
                        rowData={props.meetingAgendaData}
                        getRowStyle={(params) => {
                          if (params.data.deleteYn === 'Y') {
                            return {
                              backgroundColor: '#ffcdd2',
                              opacity: 0.8,
                              textDecoration: 'line-through',
                              color: '#b71c1c',
                              fontWeight: 'bold',
                              border: '1px solid #d32f2f',
                              boxShadow: '0 2px 4px rgba(211, 47, 47, 0.3)',
                            };
                          }
                          return null;
                        }}
                        onCellValueChanged={(e) => {
                          const updatedData = props.meetingAgendaData.map(
                            (item) => {
                              if (item.id === e.data.id) {
                                return {
                                  ...item,
                                  [e.colDef.field]: e.newValue,
                                  editYn: 'Y',
                                };
                              }
                              return item;
                            }
                          );

                          props.setMeetingAgendaData(updatedData);
                        }}
                        defaultColDef={{
                          resizable: true,
                          sortable: true,
                          filter: true,
                        }}
                        stopEditingWhenCellsLoseFocus={true}
                        suppressKeyboardEvent={(params) => {
                          if (params.event.key === 'Tab') {
                            return false;
                          }
                          return false;
                        }}
                        onCellKeyDown={(params) => {
                          if (params.event.key === 'Tab') {
                            const currentRowIndex = params.rowIndex;
                            const currentColId = params.column.getColId();
                            const columnDefs = params.api.getColumnDefs();
                            const currentColIndex = columnDefs.findIndex(
                              (col) => col.field === currentColId
                            );

                            if (currentColIndex < columnDefs.length - 1) {
                              const nextColKey =
                                columnDefs[currentColIndex + 1].field;
                              params.api.setFocusedCell(
                                currentRowIndex,
                                nextColKey
                              );
                              params.api.startEditingCell({
                                rowIndex: currentRowIndex,
                                colKey: nextColKey,
                              });
                              params.event.preventDefault();
                            } else {
                              const nextRowIndex = currentRowIndex + 1;
                              if (
                                nextRowIndex < params.api.getDisplayedRowCount()
                              ) {
                                const firstColKey = columnDefs[0].field;
                                params.api.setFocusedCell(
                                  nextRowIndex,
                                  firstColKey
                                );
                                params.api.startEditingCell({
                                  rowIndex: nextRowIndex,
                                  colKey: firstColKey,
                                });
                                params.event.preventDefault();
                              }
                            }
                          }
                        }}
                      />
                    </div>
                  </Paper>
                </Box>
              </Box>
            }
          />
        )}
        {/* 참석인원 추가 팝업 창 */}
        {props.modalToggle3 && (
          <Dialog
            title={null}
            titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
            open={props.modalToggle3}
            onClose={() => props.setModalToggle3(false)}
            contentSx={{
              p: '0 !important',
              pt: '0 !important',
              pb: '0 !important',
              px: '0 !important',
              py: '0 !important',
              m: '0 !important',
              mt: '0 !important',
              overflow: 'hidden',
              '&.MuiDialogContent-root': {
                padding: '0 !important',
                paddingTop: '0 !important',
              },
            }}
            fullWidth
            maxWidth="lg"
            saveButtonName="확인"
            closeButtonName="취소"
            useSaveButton={true}
            useSaveAfterClose={false}
            useCloseButton={false}
            onSave={() => {
              const targetGubun =
                props.attendeeAddTargetGubunRef?.current === '1' ? '1' : '0';
              const existingList =
                targetGubun === '1' ? props.attendeeData1 : props.attendeeData0;
              const setList =
                targetGubun === '1'
                  ? props.setAttendeeData1
                  : props.setAttendeeData0;

              const newAttendees = props.selectedWorkers.map((worker) =>
                mapWorkerToAttendeeRow(worker, targetGubun)
              );

              const filteredNewAttendees = newAttendees.filter(
                (newAttendee) => {
                  return !existingList.some((existingAttendee) => {
                    return (
                      existingAttendee.id === newAttendee.id &&
                      existingAttendee.tel === newAttendee.tel
                    );
                  });
                }
              );

              setList([...existingList, ...filteredNewAttendees]);

              props.setModalRowData2((prev) => ({
                ...prev,
                totalWorkers:
                  (targetGubun === '0'
                    ? existingList.length + filteredNewAttendees.length
                    : props.attendeeData0.length) +
                  (targetGubun === '1'
                    ? existingList.length + filteredNewAttendees.length
                    : props.attendeeData1.length),
              }));

              if (filteredNewAttendees.length < newAttendees.length) {
                const duplicateCount =
                  newAttendees.length - filteredNewAttendees.length;
                props.dispatch(
                  props.showSnackbar({
                    message: `${duplicateCount}명의 중복된 참석자가 제외되었습니다.`,
                    type: 'warning',
                  })
                );
              }

              props.setSelectedWorkers([]);
              props.setModalToggle3(false);
            }}
            content={
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  bgcolor: '#f6f7f8',
                  p: 0,
                  m: 0,
                  mt: 0,
                  pt: 0,
                  overflow: 'hidden',
                }}
              >
                {/* Top Navigation Bar */}
                <Paper
                  elevation={0}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #f0f2f4',
                    bgcolor: 'white',
                    px: 3,
                    py: 1,
                    flexShrink: 0,
                    zIndex: 20,
                    m: 0,
                    mt: 0,
                    pt: 1,
                    pb: 1,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: '#111418',
                    }}
                  >
                    참석인원 추가
                  </Typography>
                  <IconButton
                    onClick={() => props.setModalToggle3(false)}
                    sx={{
                      color: '#5f6368',
                      '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Paper>

                {/* Main Content */}
                <Box
                  sx={{
                    display: 'flex',
                    flex: 1,
                    gap: 2,
                    p: 2,
                    overflow: 'hidden',
                  }}
                >
                  {/* 왼쪽: 검색 결과 리스트 */}
                  <Paper
                    elevation={0}
                    sx={{
                      flex: 1,
                      p: 2,
                      minWidth: '300px',
                      bgcolor: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <TextField
                        placeholder="이름 또는 사번으로 검색"
                        variant="outlined"
                        size="small"
                        sx={{ flex: 1 }}
                        value={props.searchKeyword}
                        onChange={(e) => props.setSearchKeyword(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            props.handleSearchWorkers();
                          }
                        }}
                      />
                      <Button
                        variant="contained"
                        onClick={props.handleSearchWorkers}
                        sx={{
                          minWidth: '80px',
                          bgcolor: '#1976d2',
                          '&:hover': {
                            bgcolor: '#1565c0',
                          },
                        }}
                      >
                        검색
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          // 전체 선택
                          const allWorkers = props.modalRowData3 || [];
                          props.setSelectedWorkers([...allWorkers]);
                        }}
                        sx={{
                          minWidth: '80px',
                          borderColor: '#e0e0e0',
                          color: '#5f6368',
                          '&:hover': {
                            borderColor: '#1976d2',
                            bgcolor: 'rgba(25, 118, 210, 0.04)',
                          },
                        }}
                      >
                        전체선택
                      </Button>
                    </Box>
                    <div
                      className="ag-theme-alpine"
                      style={{ height: '550px', width: '100%' }}
                    >
                      <BusinessGridCommon
                        addYn1={'N'}
                        deleteYn1={'N'}
                        refreshYn1={'N'}
                        pagination={false}
                        suppressCellFocus={true}
                        suppressRowClickSelection={true}
                        animateRows={false}
                        getRowId={(params) => {
                          const row = normalizeAttendeeWorkerRow(
                            params.data || {}
                          );
                          return (
                            getAttendeeWorkerKey(row) ||
                            `row-${params.rowIndex}`
                          );
                        }}
                        setSelectedRowData={() => {}}
                        onCellClicked={(params) => {
                          const worker = params.data;
                          if (!worker) return;

                          const normalized = normalizeAttendeeWorkerRow(worker);
                          const uniqueKey = getAttendeeWorkerKey(normalized);

                          const isSelected = props.selectedWorkers.some(
                            (selectedWorker) =>
                              getAttendeeWorkerKey(selectedWorker) === uniqueKey
                          );

                          if (isSelected) {
                            props.setSelectedWorkers(
                              props.selectedWorkers.filter(
                                (selectedWorker) =>
                                  getAttendeeWorkerKey(selectedWorker) !==
                                  uniqueKey
                              )
                            );
                          } else {
                            props.setSelectedWorkers([
                              ...props.selectedWorkers,
                              normalized,
                            ]);
                          }

                          params.api.clearFocusedCell();
                        }}
                        getRowStyle={(params) => {
                          const worker = params.data;
                          if (!worker) return {};

                          const uniqueKey = getAttendeeWorkerKey(
                            normalizeAttendeeWorkerRow(worker)
                          );
                          const isSelected = props.selectedWorkers.some(
                            (selectedWorker) =>
                              getAttendeeWorkerKey(selectedWorker) === uniqueKey
                          );

                          if (isSelected) {
                            return {
                              backgroundColor: '#e3f2fd',
                              cursor: 'pointer',
                            };
                          }
                          return { cursor: 'pointer' };
                        }}
                        columnDefs={getAttendeePickerColumnDefs()}
                        rowData={props.modalRowData3?.filter((worker) => {
                          if (!props.searchKeyword.trim()) return true;
                          const keyword = props.searchKeyword.toLowerCase();
                          const row = normalizeAttendeeWorkerRow(worker);
                          return (
                            row.name?.toLowerCase().includes(keyword) ||
                            row.empNo?.toLowerCase().includes(keyword) ||
                            row.depNm?.toLowerCase().includes(keyword) ||
                            row.rank?.toLowerCase().includes(keyword) ||
                            row.position?.toLowerCase().includes(keyword)
                          );
                        })}
                        defaultColDef={{
                          minWidth: 80,
                          resizable: true,
                          sortable: true,
                        }}
                      />
                    </div>
                  </Paper>

                  {/* 오른쪽: 선택된 항목 리스트 */}
                  <Paper
                    elevation={0}
                    sx={{
                      width: '400px',
                      p: 2,
                      bgcolor: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 2,
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: '#111418',
                        }}
                      >
                        선택된 참석자 ({props.selectedWorkers.length}명)
                      </Typography>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => {
                          props.setSelectedWorkers([]);
                        }}
                        disabled={props.selectedWorkers.length === 0}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                        }}
                      >
                        전체삭제
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        flex: 1,
                        overflow: 'auto',
                        minHeight: 0,
                      }}
                    >
                      {props.selectedWorkers.map((worker, index) => {
                        const row = normalizeAttendeeWorkerRow(worker);
                        const workerId = row.id || index;
                        const workerName = row.name || '';
                        const detailLine = [
                          row.depNm,
                          row.rank ? `직위 ${row.rank}` : '',
                          row.position ? `직책 ${row.position}` : '',
                        ]
                          .filter(Boolean)
                          .join(' · ');
                        return (
                          <Paper
                            key={workerId}
                            elevation={0}
                            sx={{
                              p: 1.5,
                              mb: 1,
                              bgcolor: '#f8f9fa',
                              border: '1px solid #e0e0e0',
                              borderRadius: 2,
                              position: 'relative',
                              display: 'flex',
                              alignItems: 'center',
                              '&:hover': {
                                bgcolor: '#f0f0f0',
                              },
                            }}
                          >
                            <AccountCircleIcon
                              sx={{
                                fontSize: 40,
                                color: '#1976d2',
                                mr: 1.5,
                              }}
                            />
                            <Box sx={{ flex: 1 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: 600,
                                  color: '#111418',
                                  mb: 0.5,
                                }}
                              >
                                {workerName}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: '#5f6368',
                                  fontSize: 12,
                                }}
                              >
                                {detailLine || '-'}
                              </Typography>
                            </Box>
                            <IconButton
                              size="small"
                              onClick={() => {
                                props.setSelectedWorkers(
                                  props.selectedWorkers.filter(
                                    (_, i) => i !== index
                                  )
                                );
                              }}
                              sx={{
                                color: '#5f6368',
                                '&:hover': {
                                  bgcolor: 'rgba(244, 67, 54, 0.1)',
                                  color: '#d32f2f',
                                },
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </Paper>
                        );
                      })}
                      {props.selectedWorkers.length === 0 && (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            textAlign: 'center',
                            py: 4,
                          }}
                        >
                          <PersonAddIcon
                            sx={{
                              fontSize: 64,
                              color: '#9e9e9e',
                              mb: 2,
                            }}
                          />
                          <Typography
                            variant="body1"
                            sx={{
                              color: '#5f6368',
                              mb: 1,
                              fontWeight: 500,
                            }}
                          >
                            선택한 참석자가 없어요
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#9e9e9e',
                              fontSize: 14,
                            }}
                          >
                            선택된 항목을 여기에서 확인하실 수 있어요
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Paper>
                </Box>
              </Box>
            }
          />
        )}
      </Grid>
      <Dialog
        title="외부인원 직접입력 (사용자위원)"
        open={externalUserMemberModalOpen}
        onClose={() => {
          setExternalUserMemberModalOpen(false);
          setExternalUserMemberForm({
            depNm: '',
            rank: '',
            position: '',
            name: '',
            tel: '',
          });
        }}
        maxWidth="sm"
        fullWidth
        useSaveButton={true}
        saveButtonName="추가"
        useSaveAfterClose={false}
        useCloseButton={true}
        closeButtonName="취소"
        onSave={ConfirmAddExternalUserCommitteeMember}
        content={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              pt: 1,
            }}
          >
            <TextField
              label="소속"
              size="small"
              fullWidth
              value={externalUserMemberForm.depNm}
              onChange={(e) =>
                setExternalUserMemberForm((prev) => ({
                  ...prev,
                  depNm: e.target.value,
                }))
              }
            />
            <TextField
              label="직위"
              size="small"
              fullWidth
              value={externalUserMemberForm.rank}
              onChange={(e) =>
                setExternalUserMemberForm((prev) => ({
                  ...prev,
                  rank: e.target.value,
                }))
              }
            />
            <TextField
              label="직책"
              size="small"
              fullWidth
              value={externalUserMemberForm.position}
              onChange={(e) =>
                setExternalUserMemberForm((prev) => ({
                  ...prev,
                  position: e.target.value,
                }))
              }
            />
            <TextField
              label="이름"
              size="small"
              fullWidth
              required
              value={externalUserMemberForm.name}
              onChange={(e) =>
                setExternalUserMemberForm((prev) => ({
                  ...prev,
                  name: e.target.value,
                }))
              }
            />
            <TextField
              label="전화번호"
              size="small"
              fullWidth
              value={externalUserMemberForm.tel}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                autoComplete: 'tel',
              }}
              onChange={(e) => {
                const digitsOnly = e.target.value.replace(/\D/g, '');
                setExternalUserMemberForm((prev) => ({
                  ...prev,
                  tel: digitsOnly,
                }));
              }}
            />
          </Box>
        }
      />
    </>
  );
}

export default SAC_BASIC;
